module.exports = __webpack_public_path__ + "static/media/aboutme1.85c58528.jpg";